import api from '@/apis'
import router from '@/router'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    mode: 'create', // `create` or `edit`
    info: { intent_name: null, category_id: null, parent_id: null },
    is_submit_btn_disable: false,
    autocomplete_items: []
  },
  mutations: {
    INIT_QUESTION_TOPIC_MNGT_DIALOG(state, { mode, info = null }) {
      state.visibility = true
      state.mode = mode

      if (info) state.info = { ...info }
      else state.info = { intent_name: null, category_id: null, parent_id: null }
    },
    RESET_QUESTION_TOPIC_MNGT_DIALOG(state) {
      state.visibility = false
      state.mode = 'create'
      state.info = { intent_name: null, category_id: null, parent_id: null }
      state.autocomplete_items = []
    },
    SET_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    },
    SET_QUESTION_TOPIC_MNGT_DIALOG_AUTOCOMPLETE_ITEMS(state, payload) {
      state.autocomplete_items = payload
    },
    SET_QUESTION_TOPIC_MNGT_DIALOG_INFO_INTENT_NAME(state, payload) {
      state.info.intent_name = payload
    }
  },
  actions: {
    async fetchQuestionTopicAutocomplete({ commit }, payload) {
      try {
        const response = await api.getQuestionTopicAutocomplete({ text: payload })
        if (response.data.success) {
          commit('SET_QUESTION_TOPIC_MNGT_DIALOG_AUTOCOMPLETE_ITEMS', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },

    async addQuestionTopic({ rootState, state, commit, dispatch }) {
      try {
        const device_id = rootState.auth.selected_device
        const { parent_id = null, intent_name, category_id = null, remarks = null, memo = null } = state.info
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__General.question_topic')),
          loading: true
        })
        commit('SET_IS_SUBMIT_BTN_DISABLE', true)

        // If parent_id isn't null, it means it creating sub-topic -> no category
        // else it is creating topic question -> has category
        const params = { device_id, name: intent_name }
        if (parent_id) params.parent_id = parent_id
        else params.category_id = category_id
        params.remarks = remarks
        params.memo = memo

        const response = await api.addQuestionTopic({ params })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__General.question_topic')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_QUESTION_TOPIC_MNGT_DIALOG')

          const created_id = response.data.data.id
          if (parent_id) router.push({ path: `/ai/keyword/question/${created_id}` })
          else dispatch('fetchQuestionTopicList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_IS_SUBMIT_BTN_DISABLE', false)
      }
    },
    async editQuestionTopic({ rootState, state, commit }) {
      try {
        const device_id = rootState.auth.selected_device
        const { id, intent_name, category_id, is_activated, remarks, memo } = state.info
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.editing', Vuetify.locale.t('$vuetify.__General.question_topic')),
          loading: true
        })
        commit('SET_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.updateQuestionTopic({ params: { device_id, id, name: intent_name, category_id, is_activated, remarks, memo } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.edit', Vuetify.locale.t('$vuetify.__General.question_topic')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_QUESTION_TOPIC_MNGT_DIALOG')
          window.location.reload() // page reload
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
